import get from 'lodash/get'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import PriceConverter from '../helpers/PriceConverter'
import AvailableDates from './AvailableDate'
import './adventure-card.scss'
import AdventureOriginalTitle from './AdventureOriginalTitle'

function ConservationSliderCard({ adventure, isWidget, selectedCurrency }) {
  const picture = get(adventure, 'picture["800x800"]', '')
  const currency = get(adventure, 'price.currency')
  const price = get(adventure, 'price.price')
  const isFree = parseFloat(price) === 0

  const handleClick = () => {
    if(adventure.impression) {
      window.dataLayer.push({
        event: 'productClick',
        ecommerce: {
          currencyCode: selectedCurrency,
          click: {
            actionField: { list: adventure.actionField },
            products: [adventure.impression],
          },
        },
      })
    }
  }

  const prevQueryParams = window.location.search
    ? window.location.search.replace('?', '&')
    : ''
  return (
    <div className='adventure-card'>
      <a
        href={`${adventure.activityPage}${
          isWidget ? prevQueryParams + '&widget=true' : prevQueryParams
        }`}
        onClick={handleClick}
        className='adventure-url'
      />
      <div className='img-wrapper'>
        <img src={picture} className='img' alt='adventure card' />
      </div>

      <div className='info'>
        <strong className='adventure-card__title'>
          {adventure.title}
          <AdventureOriginalTitle
            originalTitle={adventure.originalTitle}
            title={adventure.title}
          />
        </strong>
        <p className='dive-center-title'>{adventure.diveCenter.title}</p>
        <p className='adventure-card__availability'>
          <AvailableDates date={adventure.availableDate || adventure.date} />
        </p>
        <div className='adventure-card__price'>
          <span className='pricing'>
            {isFree ? (
              <FormattedMessage id='free' defaultMessage='Free' />
            ) : (
              <PriceConverter
                amount={price}
                currency={currency}
                conversionPercent
              />
            )}
          </span>
        </div>
      </div>
    </div>
  )
}

export default connect((state) => ({
  selectedCurrency: state.selectedCurrency,
}))(ConservationSliderCard)
